(function ($, Global) {
    var MESSAGE_COOKIE_NOTIF = 'Message_Notif_hidden';
    var MessageNotifComponent = function () {
        this.selector = '.message-push-notification';
        this.$el = $(this.selector);
        this.cookieManager = new Global.CookieManager();
        this.cookieValue = Global.Cookie.get(MESSAGE_COOKIE_NOTIF)
    };

    MessageNotifComponent.prototype.initEvents = function () {
        this.publishers();
        this.subscribers();
    };

    MessageNotifComponent.prototype.publishers = function () {
        var self = this;   

        $(document).ready(function () {
            if (!('Notification' in window) || !('serviceWorker' in navigator) || Notification.permission == "denied") return;
            if (Notification.permission !== 'default' && Global.NOTIF_TAGS.publication !== "Glitz") return;
            

            self.handleShowBox();
        });

        $(document).on('click', self.selector + ' > .close', function () {
            $.Topic('message-notif-hide').publish();
            $.Topic('message-notif-cookie-create').publish();
        });

        $(document).on('click', self.selector + ' .btn-action', function () {
            var services = self.cookieManager.servicesActivate();

            if (services.indexOf('oneSignal') < 0) services.push('oneSignal');
            
            self.cookieManager.approve(services);
            clearInterval(timer);
            var timer = setInterval(function () {
                if (Global.OneSignal) {
                    $.Topic('notif-subscribe').publish();
                    clearInterval(timer);
                }
            }, 1000)
        });

        $(document).on('click', self.selector + ' .btn-info', function () {
            self.$el.find('.tip').addClass('in');
        });

        $(document).on('click', self.selector + ' .close', function () {
            self.$el.find('.tip').removeClass('in');
            self.handleWriteCookie(14)
        });
    };

    MessageNotifComponent.prototype.subscribers = function () {
        var self = this;

        $.Topic('message-notif-show').subscribe(function () {
            self.$el.addClass('in');
        });

        $.Topic('message-notif-hide').subscribe(function () {
            self.$el.removeClass('in');
            self.$el.remove();
        });

        $.Topic('message-notif-cookie-create').subscribe(function () {
            self.handleWriteCookie(60)
        });
    };

    MessageNotifComponent.prototype.handleWriteCookie = function (period) {
        var value = 1;
        if (Global.NOTIF_TAGS.publication == "Glitz") {
            if (Global.NOTIF_TAGS.fr && Global.NOTIF_TAGS.fr == 1 && this.cookieValue == null) value = 2;
            if (Global.NOTIF_TAGS.en && Global.NOTIF_TAGS.en == 1 && this.cookieValue == null) value = 3;
        }
        this.cookieValue = value
        Global.Cookie.create(MESSAGE_COOKIE_NOTIF, this.cookieValue, period);
    }

    MessageNotifComponent.prototype.handleShowBox = function () {
        var self = this;

        if ($(window).width() >= Global.viewports.md) {
            setTimeout(function () {
                $.Topic('message-notif-show').publish();
            }, 8000);
        } else if (!self.$el.hasClass('in')) {
            $(window).on('scroll', function () {
                if ($(window).scrollTop() > 100) {
                    $.Topic('message-notif-show').publish();
                }
            });
        }
    };

    Global.MessageNotifComponent = MessageNotifComponent;
}(jQuery, window));